import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgOk({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.294 13.179a1.5 1.5 0 011.414 2.646 9.944 9.944 0 01-1.968.795l2.32 2.32a1.5 1.5 0 01-2.007 2.224l-.114-.103L12 18.12l-2.94 2.94a1.5 1.5 0 01-2.224-2.008l.103-.114 2.321-2.32a9.945 9.945 0 01-1.963-.792 1.5 1.5 0 011.413-2.646 6.95 6.95 0 002.942.81l.229.006.119-.118.12.12a6.957 6.957 0 003.174-.82zM12 2a5 5 0 110 10 5 5 0 010-10zm0 3a2 2 0 100 4 2 2 0 000-4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgOk
